
(function documentTypeDefinition() {
    'use strict';
    angular.module('Entities')
        .service('documentTypeService', [
            'restUrlBuilder', 'authExtend', '$q', '$filter', 'config', function documentTypeService(restUrlBuilder, auth, $q, $filter, config) {
                var that = this;
                var functionsDTypes = undefined;
                var promiseFunctionType = undefined;

                auth.onIdentityChanged(function () {
                    that.ClearFunctionsDTypes();
                });

                this.ClearFunctionsDTypes = function () {
                    functionsDTypes = undefined;
                    promiseFunctionType = undefined;
                }

                this.getById = function getById(id, detailLevel, functions) {

                    var params = { lod: detailLevel, function: functions };

                    return restUrlBuilder.one('documentTypes', id)
                        .get({ params: params });
                };

                this.get = function get(functions, useCalendar) {

                    var params = { Functions: functions, UseCalendar: useCalendar };


                    return restUrlBuilder.all('documentTypes')
                        .get({ params: params });
                };

                this.getByContainerId = function get(containerTypes, functions) {
                    var params = { ContainerTypeIds: containerTypes, Functions: functions };

                    return restUrlBuilder.all('documentTypes')
                        .get({ params: params });
                };

                this.getFunctionsDocTypes = function getDT() {
                    if (functionsDTypes) {
                        var defered = $q.defer();
                        var promise = defered.promise;
                        defered.resolve(functionsDTypes);
                        return promise;
                    }

                    if (promiseFunctionType) {
                        return promiseFunctionType;
                    }

                    promiseFunctionType = restUrlBuilder.one('functions', config.appId())
                        .all('documentTypes')
                        .get();

                    return promiseFunctionType;
                }

                this.isDoctypeInRole = function (f, dtId) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    this.getFunctionsTypes(f).then(function (types) {
                        defered.resolve($filter('filter')(types, { id: dtId }, true).length > 0);
                    }, function (error) {
                        defered.reject(error);
                    });

                    return promise;
                };

                this.getFunctionsTypes = function (functions) {
                    var defered = $q.defer();
                    var promise = defered.promise;
                   
                    if (!auth.isLogged()) {
                        defered.resolve([]);
                        return promise;
                    }

                    if (!auth.isLogged()) {
                        defered.resolve([]);
                        return promise;
                    }

                    this.LoadTypes(functions).then(function (types) {
                        defered.resolve(types);
                    }, function (error) {
                        defered.reject(error);
                    });

                    return promise;
                }

                this.LoadTypes = function (functions) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    this.getFunctionsDocTypes().then(function (apiResult) {
                        functionsDTypes = apiResult;

                        var types = [];
                        functions.forEach(function (f) {
                            var results = $filter('filter')(functionsDTypes, { function: f }, true);
                            if (results.length > 0) {
                                results[0].docTypes.forEach(function (dt) {
                                    var dtr = $filter('filter')(types, { id: dt.id }, true);
                                    if (dtr.length === 0) {
                                        types.push(dt);
                                    }
                                });
                            }
                        });

                        defered.resolve(types);
                    }, function (error) {
                        defered.reject(error);
                    });

                    return promise;
                }

            }
        ]);

})();